import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ContentfulState, Helpline } from ".";

const initialState: ContentfulState = {
  data: null,
  loading: false,
  dynamicBanner: null,
  helplines: [],
};

export const contentfulSlice = createSlice({
  name: "contentful",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setContentful: (state, action) => {
      state.data = action.payload;
    },
    setDynamicBanner: (state, action) => {
      state.dynamicBanner = action.payload;
    },
    setHelplines: (state, action: PayloadAction<Helpline[]>) => {
      state.helplines = action.payload;
    },
  },
});

const contentfulReducer = contentfulSlice.reducer;

export const contentfulActions = contentfulSlice.actions;
export default contentfulReducer;
